var map = {
	"./arrowRight.png": 71839,
	"./bgApplyStar.png": 65274,
	"./bgBuyStar.png": 18603,
	"./bgDialogue.png": 60775,
	"./bgInput.png": 71518,
	"./bgSword.png": 54159,
	"./star.png": 51452
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72435;